import React, { Component } from 'react';
import $ from "jquery";
import {
    AreYouAgreeModal,
} from "./index";
import moment from 'moment';
import { Envasados, Granel } from '../libs/utils/Const';

class RoadMapPreviewModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAreYouAgreeModal: false,
        };

        this.newModelCopy = '';
    };

    componentDidMount = () => {
        this._handelBack();
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    openAction = () => {
        $('#roadMapModal').on('hide.bs.modal', function () {
        });
    };

    closeModal = () => {
        const { CloseRoadmapPreview } = this.props
        $('#roadMapModal').modal('hide');
        this.setState({
            showAreYouAgreeModal: false,
        });
        CloseRoadmapPreview();
    };

    sendModel = async () => {
        const { sendModel, RoadmapPreview, showAlert } = this.props;

        showAlert({ type: 'info', message: "Se estan generando las solicitudes de traslado...", timeOut: 5000 });
        sendModel(RoadmapPreview);
        this.closeModal()
        this.setState({
            showAreYouAgreeModal: false,
        });
    };

    OpenAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });

        $('#areYouAgreeModal').modal('show');
    };

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    };

    renderAdminUsersHeader = (docs) => {
        // const { option } = this.props;
        // const { typeVisibility } = this.state;
        return (
            <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*CÓDIGO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Folio</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={docs.Code ? docs.Code : ""} />
                    </div>

                    {/*NOMBRE DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={docs.TransferRoute != null ? 'Transferido' : docs?.DocStatus === "O" ? 'Abierto' : 'Cerrado'} />
                    </div>

                    {/*CORREO DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={moment(docs?.DocDate).format("DD-MM-YYYY") ?? 'N/A'}
                        />
                    </div>

                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*TIPO DE USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Transporte</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={`${docs.TipodeUnidad ?? ''} - Matricula: ${docs.PlacaVM ?? ''}`}
                        />
                    </div>

                    {/*CORREO DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Chofer</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={(docs?.firstName ?? "") + '' + (docs?.lastName ?? "")}
                        />
                    </div>

                    {/*CORREO DEL USUARIO*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Tipo de atención</span>
                                <span className="d-inline d-xl-none">T. atención</span>
                            </span>
                        </div>
                        <input type="text" className="form-control"
                            disabled
                            value={(docs?.AttentionType === 'RCF' ? 'Ruta Cliente Final' : 'Ruta distribuidores')}
                        />
                    </div>
                </div>
                <br></br>
            </div>
        )
    };

    renderDetailsSumLines = (docs) => {
        if (docs.GroupedLines && docs.GroupedLines.length === 0) {
            return (
                <div className="row" style={{ paddingRight: 0, paddingBottom: '20px' }}>
                </div>
            )
        }
        return (
            <div className="row" style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '20px' }}>
                <div>DETALLE COMPLETO</div>
                <div className="table-responsive">
                    <table style={{ margin: '0 auto' }}>
                        <thead style={{ background: '#eee0f7', color: 'black' }}>
                            <tr>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}></th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Código artículo</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Descripción</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }} colSpan={2}>Cantidad a Solicitar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!docs.GroupedLines && docs.GroupedLines.map((cLine, index) => {
                                let qtyGalones = Number(cLine?.U_RS_CANTG ?? 0);
                                const qtyKg = Number(cLine?.QuantityKG ?? 0);

                                const showUMed = qtyGalones > 0 ? 'GLN' : '';
                                qtyGalones = qtyGalones <= 0 ? null : qtyGalones
                                const showKGLabel = Granel?.includes(cLine?.ItmsGrpCod) ? 'KGM' : cLine?.SalUnitMsr ?? '';
                                return (
                                    <tr style={{ borderBottom: '1 px solid #eee0f7' }}>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{index + 1}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.ItemCode || ""}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.Dscription || ""}</td>
                                        {/* <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7', borderRight: '1px solid #eee0f7' }} className="text-right" >{Number(cLine.Quantity || 0).toFixed(2)}</td> */}
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{qtyGalones?.toFixed(4) ?? ''} {showUMed}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{qtyKg.toFixed(2)} {showKGLabel}</td>
                                    </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    };

    quantityItem = (line) => {
        let quantity = 0.00;
        let unitMsr = line?.SalUnitMsr ?? '';
        // if (line.U_RS_TIPOV == 'GRANEL') {
        if (line.U_RS_UMED === 'GLN') {
            quantity = Number(line?.U_RS_CANTG ?? 0).toFixed(4)
        } else {
            quantity = Number(line?.Quantity ?? 0).toFixed(2)
        }
        if (Granel.includes(Number(line?.ItmsGrpCod ?? -1))) {
            unitMsr = line?.U_RS_UMED ?? ''
        }
        return `${quantity} ${unitMsr}`
    }

    renderDetailsLines = (docs) => {
        if (docs.DocumentLines && docs.DocumentLines.length === 0) {
            return (
                <div className="row" style={{ paddingRight: 0, paddingBottom: '20px' }}>
                </div>
            )
        }
        return (
            <div className="row" style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '20px' }}>
                <div>DETALLE LINEAS</div>
                <div className="table-responsive">
                    <table>
                        <thead style={{ background: '#eee0f7', color: 'black' }}>
                            <tr>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Tipo doc.</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>N° doc.</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Socio de negocio</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Código artículo</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Descripción</th>
                                <th className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Cant. sistema</th>
                                {/* <th className="text-left" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Cant.<br /> cargada</th> */}
                                {/* <th className="text-left" style={{ paddingBottom: '5px', paddingTop: '5px' }}>Oberservaciones</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {!!docs.DocumentLines && docs.DocumentLines.map((cLine) => {
                                return (
                                    <tr style={{ borderBottom: '1 px solid #eee0f7' }}>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }} className="text-center">{cLine.ObjType === '17' ? 'OV' : cLine.ObjType === '13' ? 'FAC' : 'ENT'}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.DocNum || ""}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.CardName || ""}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.ItemCode || ""}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{cLine.Dscription || ""}</td>
                                        <td className="text-center" style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7', borderRight: '1px solid #eee0f7' }} className="text-right" >{this.quantityItem(cLine)}</td>
                                        {/* <td style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{''}</td> */}
                                        {/* <td style={{ paddingBottom: '5px', paddingTop: '5px', borderLeft: '1px solid #eee0f7' }}>{''}</td> */}
                                    </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    };

    render() {
        const {
            RoadmapPreview,
        } = this.props;
        const {
            showAreYouAgreeModal,
        } = this.state;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="roadMapModal"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estas seguro que deseas crear la solicitud de traslado?'}
                        accept={this.sendModel}
                        cancel={this.CloseShowAreYouAgreeModal}
                    />
                }

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Vista Previa de Hojas de Ruta</h4>
                            <button type="button" className="close" onClick={() => this.closeModal()} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            {!!RoadmapPreview && RoadmapPreview.map((docs) => {
                                                return (
                                                    <>
                                                        {this.renderAdminUsersHeader(docs)}
                                                        {this.renderDetailsSumLines(docs)}
                                                        {this.renderDetailsLines(docs)}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {/* <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}>
                                Crear
                            </button> */}

                            <button type="button" className="btn botonCorrect text-black" onClick={this.OpenAreYouAgreeModal}>
                                Generar Solicitud de traslado
                            </button>

                            <button type="button" className="btn botonCerrar text-white" onClick={() => this.closeModal()}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}

export default RoadMapPreviewModal;